import { render, staticRenderFns } from "./ServeCountForHandle.vue?vue&type=template&id=b0a63d54&scoped=true&"
import script from "./ServeCountForHandle.vue?vue&type=script&lang=js&"
export * from "./ServeCountForHandle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0a63d54",
  null
  
)

export default component.exports